(function () {
  function getSelectedOptions(variantSelects) {
    const options = [];

    variantSelects.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((group) => {
      const checked = group.querySelector('input:checked');
      const select = group.querySelector('select');

      if (checked) options.push(checked.value.trim());
      else if (select) options.push(select.value.trim());
    });

    return options;
  }

  function updateStockBadge(variantSelects) {
    const section = variantSelects.closest('product-info') || document;
    const badge = section.querySelector('[data-cc-stock-status]');
    const json = section.querySelector('[data-cc-variants-json]');

    if (!badge || !json) return;

    const variants = JSON.parse(json.textContent);
    const selectedOptions = getSelectedOptions(variantSelects);

    const variant = variants.find((v) =>
      v.options.every((option, index) => String(option).trim() === selectedOptions[index])
    );

    if (!variant) return;

    const inStock = Number(variant.inventory_quantity || 0) > 0;

    badge.classList.remove('cc-stock', 'cc-delay');
    badge.classList.add(inStock ? 'cc-stock' : 'cc-delay');

    badge.innerHTML = inStock
      ? '<strong>En stock</strong>'
      : '<strong>Délai de préparation : 3 à 7 jours*</strong>';
  }

  document.addEventListener('change', function (event) {
    const variantSelects = event.target.closest('variant-selects');
    if (!variantSelects) return;

    requestAnimationFrame(() => updateStockBadge(variantSelects));
  });
})();